/**
 * App-level icon constants for the platform shell.
 *
 * These map each top-level app (Prospecting, In-Queue, etc.) to its
 * Blueprint icon name and live here rather than in RouterApp so that
 * routing constants stay separate from UI concerns.
 */
export const PROSPECTING_ICON = "path-search";
export const IN_QUEUE_ICON = "folder-shared-open";
